import React from 'react';
import Reveal from '../ui/Reveal';
import SpotCard from './SpotCard';
import { bentoItems } from '../../data/masterclass';

const ClassBentoSection: React.FC = () => {
  return (
    <section id="clase" className="relative scroll-mt-36 py-24 md:py-28">
      <div className="mx-auto max-w-7xl px-5">
        <Reveal className="max-w-2xl">
          <div className="mb-4 flex items-center gap-3">
            <span className="text-sm text-white/30">02</span>
            <span className="eyebrow-mc text-mc-fuchsia">La clase</span>
          </div>
          <h2 className="font-display text-3xl font-bold leading-[1.1] md:text-5xl">
            ¿Qué vas a descubrir en esta clase?
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-5 md:grid-cols-3">
          {bentoItems.map((item, index) => {
            const hasImage = Boolean(item.image);
            return (
              <Reveal
                key={item.number}
                delay={index * 80}
                className={hasImage ? 'md:col-span-2' : undefined}
              >
                <SpotCard
                  className={`h-full overflow-hidden rounded-[24px] border border-white/10 bg-white/5 backdrop-blur-md ${
                    hasImage ? 'grid md:grid-cols-[1fr_260px]' : ''
                  }`}
                >
                  <div className="flex flex-col gap-6 p-8 sm:flex-row sm:items-center">
                    <div className="grid h-14 w-14 shrink-0 place-items-center rounded-2xl bg-mc-gradient font-display text-lg font-extrabold text-white">
                      {item.number}
                    </div>
                    <div>
                      <div className="eyebrow-mc text-white/45">{item.eyebrow}</div>
                      <h3 className="mt-1 font-display text-2xl font-bold">{item.title}</h3>
                      <p className="mt-2 font-light leading-relaxed text-white/65">{item.description}</p>
                    </div>
                  </div>
                  {hasImage && (
                    <div className={`relative hidden md:block ${item.imageSide === 'left' ? 'md:order-first' : ''}`}>
                      <img
                        src={item.image}
                        alt={item.imageAlt}
                        loading="lazy"
                        className="absolute inset-0 h-full w-full animate-kenburns object-cover"
                      />
                      <div
                        className="absolute inset-0"
                        style={{
                          background:
                            item.imageSide === 'left'
                              ? 'linear-gradient(270deg, rgba(10,18,54,.99), rgba(10,18,54,.35))'
                              : 'linear-gradient(90deg, rgba(10,18,54,.99), rgba(10,18,54,.35))',
                        }}
                      />
                    </div>
                  )}
                </SpotCard>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={160} className="mt-10">
          <a href="#registro" className="btn-mc-glow inline-block px-8 py-3.5">
            Quiero participar gratis
          </a>
        </Reveal>
      </div>
    </section>
  );
};

export default ClassBentoSection;
